// Referral reward status (docs/referral-program.md §9) ve credit ledger type
// (§10) -> badge label + Tailwind sınıfları. finance-v2'deki payoutStatusUtils
// desenini izler: config map + bilinmeyen kodda zarifçe geri düşen resolver.

const TONE = {
  amber: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  violet:
    'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300',
  emerald:
    'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  slate: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300',
  rose: 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
};

export const referralStatusConfig = {
  0: { label: 'Pending', className: TONE.amber },
  5: { label: 'Under review', className: TONE.violet },
  10: { label: 'Active', className: TONE.emerald },
  20: { label: 'Expired', className: TONE.slate },
  30: { label: 'Revoked', className: TONE.rose },
  40: { label: 'Rejected', className: TONE.rose },
};

export const ledgerTypeConfig = {
  10: { label: 'Issued', className: TONE.emerald },
  20: { label: 'Consumed', className: TONE.blue },
  30: { label: 'Expired', className: TONE.slate },
  40: { label: 'Revoked', className: TONE.rose },
  50: { label: 'Adjustment', className: TONE.violet },
};

const FALLBACK = { label: 'Unknown', className: TONE.slate };

// `fallbackLabel`: bilinmeyen kodda API'nin statusname/typename değeri
// verilirse "Unknown" yerine o anlamlı etiket gösterilir.
export const getReferralStatusConfig = (status, fallbackLabel) => {
  const config = referralStatusConfig[status];
  if (config) return config;
  return fallbackLabel
    ? { label: fallbackLabel, className: TONE.slate }
    : FALLBACK;
};

export const getLedgerTypeConfig = (type, fallbackLabel) => {
  const config = ledgerTypeConfig[type];
  if (config) return config;
  return fallbackLabel
    ? { label: fallbackLabel, className: TONE.slate }
    : FALLBACK;
};
